// extracted by mini-css-extract-plugin
module.exports = {"container":"DownloadButton__container","downloadLinks":"DownloadButton__downloadLinks"};